module.exports = __webpack_public_path__ + "img/m-banner-tcawxgez-ja-JP.d3ab8274.jpg";